<template>
	<div class="flex flex-col overflow-hidden">
		<div class="border-gray-200 relative flex flex-col overflow-hidden border-b px-4 py-2.5">
			<span class="text-neutral-900 z-[1] mb-1.5 line-clamp-1 text-sm font-bold">
				{{ (user?.firstname || "~") + " " + (user?.lastname || "~") }}
			</span>
			<span class="text-neutral-700 z-[1] line-clamp-1 text-xs">
				<span dir="ltr">
					{{ user?.mobile || user?.email || "~" }}
				</span>
			</span>
			<span v-if="user?.is_demo" class="text-neutral-700 z-[1] mt-1.5 flex items-center text-xs">
				<span class="me-1">
					{{ $t("password") + ":" }}
				</span>
				<span>
					{{ "12345678" }}
				</span>
			</span>
			<span
				v-if="user?.is_demo"
				class="z-[1] mt-2 rounded-full bg-primary/15 px-3 py-1.5 text-center text-xs font-bold text-primary"
			>
				{{ $t("demo") }}
			</span>
			<span v-if="user?.is_demo" class="text-neutral-500 z-[1] mt-2 flex items-center text-center text-xs">
				{{ $t("demo_account_delete_message") }}
			</span>
			<Icon
				name="mdi:account"
				class="-z-1 text-gray-100 absolute bottom-0 end-0 mb-4 me-2 opacity-75"
				:style="{
					transform: 'scale(5) rotate(12deg)'
				}"
			/>
		</div>
		<div class="bg-gray-50 flex flex-col shadow-inner">
			<div v-for="(item, i) in items" :key="i" class="flex flex-col" @click="() => item.click?.()">
				<NuxtLink :to="item?.link || ''" class="ripple-bg-gray-50 text-neutral-900 flex items-center px-4 py-3">
					<Icon :name="item.icon" class="me-4 h-6 w-6" />
					<span class="text-sm">
						{{ item.title }}
					</span>
				</NuxtLink>
			</div>
			<span class="ripple-bg-gray-50 text-red-500 flex cursor-pointer items-center px-4 py-3" @click="logout">
				<Icon name="mdi:logout" class="me-4 h-6 w-6" />
				<span class="text-sm">
					{{ $t("logout") }}
				</span>
			</span>
		</div>
	</div>
</template>

<script setup lang="ts">
type MenuItem = {
	title: string
	link: string
	icon: string
	click?: Function
}

const userStore = useUserStore()
const companyStore = useCompanyStore()
const app = useNuxtApp()

const emit = defineEmits<{
	"update:loading": [boolean]
	close: []
}>()

const user = computed(() => {
	return userStore.user
})

const items = computed(() => {
	return [
		["admin", "blogger", "support", "developer"].includes(user.value?.type || "") && {
			title: app.$i18n.t("manager_panel"),
			link: app.$routeUrl.AdminDashboardUrl(),
			icon: "ph:command",
			click: () => {
				companyStore.setCompany(null, null)
				emit("close")
			}
		},
		["admin", "blogger", "support", "developer", "user"].includes(user.value?.type || "") && {
			title: app.$i18n.t("dashboard"),
			link: app.$routeUrl.PanelDashboardUrl(),
			icon: "ion:grid-outline",
			click: () => {
				companyStore.setCompany(null, null)
				emit("close")
			}
		},

		["admin", "blogger", "support", "developer", "user"].includes(user.value?.type || "") && {
			title: app.$i18n.t("settings"),
			link: app.$routeUrl.PanelSettingsUrl(),
			icon: "ion:settings-outline",
			click: () => {
				companyStore.setCompany(null, null)
				emit("close")
			}
		},
		["company-user"].includes(user.value?.type || "") && {
			title: app.$i18n.t("dashboard"),
			link: app.$routeUrl.CompanyDashboardUrl(),
			icon: "ion:grid-outline",
			click: () => {
				emit("close")
			}
		},
		["company-user"].includes(user.value?.type || "") && {
			title: app.$i18n.t("settings"),
			link: app.$routeUrl.CompanySettingsUrl(),
			icon: "ion:settings-outline",
			click: () => {
				emit("close")
			}
		}
	].filter((v) => v) as MenuItem[]
})

const logout = async () => {
	emit("update:loading", true)
	const [, err] = await userStore.logout()
	if (err) app.$toastErrors(err)
	emit("update:loading", false)
}
</script>
